<a class="btn skp-btn" href="#MainContent" [attr.title]="buttonText">{{
  buttonText
}}</a>
